import * as React from 'react';
import { connect } from 'react-redux';
import { themeLogoImage } from '../../../stores/auth/selectors';
import { RootState } from '../../../stores/store';

interface Props {
    themeLogoImage?: string;
}

class Logo extends React.Component<Props> {
    public render() {
        return (
            <div
                className="splash"
                style={{
                    backgroundImage: this.props.themeLogoImage ?
                        `url(${this.props.themeLogoImage})` : ''
                }}
            />
        );
    }
}

const mapStateToProps = (state: RootState) => ({
    themeLogoImage: themeLogoImage(state)
});

export default connect(mapStateToProps)(Logo);